import React from 'react';
import { MediaPackBenchmarkType } from '~/types';

export type THighlightValue = number | string;
export interface IHighlightMultiValue {
  title?: string;
  value: THighlightValue;
  transformValue?: (value: THighlightValue) => number | string;
}

interface IHighlightCommonCard {
  description: React.ReactNode;
  title: string;
  transformValue?: (
    value?: THighlightValue,
    defaultValue?: string,
  ) => number | string;
  value?: THighlightValue;
  values?: IHighlightMultiValue[];
  lastUpdated?: string;
  metricKey?: MediaPackBenchmarkType;
}

export interface IHighlightSingleCard extends IHighlightCommonCard {
  value: THighlightValue;
}

export interface IHighlightMultiCard extends IHighlightCommonCard {
  values: IHighlightMultiValue[];
}

export type THighlightCard = IHighlightSingleCard | IHighlightMultiCard;
